import React from "react";
import { TYPOGRAPHY } from "../../constants";

// Small text link shown under the waitlist form / joined state so a visitor
// can switch between "show my referral link" and "sign up a different email"
// (e.g. a friend using this browser, or resetting state while testing).
const SessionSwitchLink = ({ onClick, children, align = "left", style = {} }) => (
  <button
    type="button"
    onClick={onClick}
    style={{
      display: "block",
      marginTop: "0.75rem", // 12px
      padding: 0,
      background: "transparent",
      border: "none",
      color: "rgba(255, 255, 255, 0.85)",
      fontSize: "0.875rem", // 14px
      fontFamily: TYPOGRAPHY.FONTS.INTER.join(", "),
      fontWeight: 400,
      textDecoration: "underline",
      textShadow: "0 1px 2px rgba(0, 0, 0, 0.5)",
      textAlign: align,
      alignSelf: align === "center" ? "center" : "flex-start",
      cursor: "pointer",
      transition: "color 0.2s ease",
      ...style,
    }}
    onMouseEnter={(e) => {
      e.target.style.color = "white";
    }}
    onMouseLeave={(e) => {
      e.target.style.color = "rgba(255, 255, 255, 0.85)";
    }}
  >
    {children}
  </button>
);

export default SessionSwitchLink;
